// Kit 01 · items 08, 11.  Kit 02 · item 50.
//
//   08 Deep link          icon 14 trailing · gap 8 · underline on hover only
//   11 Inline text link   weight 500 against body 400 · underline offset 3
//   50 Back link          icon 14 · gap 8 · weight 500
//
// keys: Enter activates. The underline appears on hover and on focus, never at
// rest — an always-underlined link inside a paragraph of them is a fence.

import type { AnchorHTMLAttributes, ReactNode } from "react";
import { ArrowUpRight, ChevronLeft } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { Icon } from "./icon";
import { cx, stateAttr } from "./kit-state";
import type { Stateful } from "./kit-state";

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement>, Stateful {
  children: ReactNode;
}

/** 08 · deep link. Trailing icon, because the icon is the destination and the
    destination comes after the name. Defaults to the external mark. */
export function DeepLink({ children, state, className, icon, ...rest }: LinkProps & { icon?: LucideIcon }) {
  return (
    <a className={cx("k-link", className)} {...stateAttr(state)} {...rest}>
      {children}
      <Icon icon={icon ?? ArrowUpRight} size="sm" />
    </a>
  );
}

/** 11 · inline. No icon: inside running text an icon is a full stop in the
    middle of a sentence. */
export function InlineLink({ children, state, className, ...rest }: LinkProps) {
  return (
    <a className={cx("k-link", "k-link--inline", className)} {...stateAttr(state)} {...rest}>
      {children}
    </a>
  );
}

/** 50 · back link. Leading chevron, because this one is a direction. */
export function BackLink({ children, state, className, ...rest }: LinkProps) {
  return (
    <a className={cx("k-link", "k-link--back", className)} {...stateAttr(state)} {...rest}>
      <Icon icon={ChevronLeft} size="sm" />
      {children}
    </a>
  );
}
